<template>
  <button
    class="niftyButton"
    :class="{
      disabledButton: !$erdAccount.logged() && !text.includes('CONNECT'),
    }"
  >
    {{ text }}
  </button>
</template>

<script lang="js">
export default {
  name: "Button",
  props: {
    text: String,
  },
};
</script>

<style scoped>
.niftyButton {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  /* padding: 20px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  /* margin: 4px 2px; */
  /* margin-right: 30px; */
  cursor: pointer;
  border-radius: 25px;
  padding-top: 5px;
  height: auto;
  width: 200px;
  padding-right: 10px;
  padding-left: 10px;
}
/*.niftyButton {
  font-family: "NiftyFont", Helvetica, Arial;
  font-size: 30px;
  background-color: #fedf25;
  font-weight: bold;
  border: 7px solid black;
}*/
.niftyButton {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border: 2px solid #0000 !important;
  font-family: "NiftyFont", Helvetica, Arial;
  font-size: 30px;
  background-color: #fedf25;
  font-weight: bold;
}
</style>
